var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 405,
    viewBox: "0 0 375 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.984 25.1945H-82.377C-328.053 25.1945 -527.213 195.239 -527.213 405",
    stroke: "#F9F9F9",
    strokeWidth: 50.39
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 360.984,
    width: 59.0164,
    height: 50.3888,
    fill: "#F70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsMobileBg);
export default __webpack_public_path__ + "static/media/AboutUs_Mobile_bg.8ee5da9a520516943972649a872dd99c.svg";
export { ForwardRef as ReactComponent };